import React from 'react';
import * as Styled from './styled';
import { Utils, Grid, Layout } from 'billon-ui';
import { FormattedMessage } from 'react-intl';
import { SubtitleToolTip } from '..';
import Modal from '../../../../../../../../ui/Modal';
import ModalHeader from '../ModalHeader';
import ModalFooter from '../ModalFooter';

const { Col, Row } = Grid;
const { Loader: LoaderModule, Text } = Utils;
const { Content: ContentModule } = Layout;
const { PageLoader } = LoaderModule;
const { Content } = ContentModule;

const SubtitlePanel = ({ children }) => (
  <Text as="h4" fontWeight={600}>
    {children}
  </Text>
);

const SelectEditTypeModal = ({
  isOpen,
  isLoading,
  onBack,
  onClose,
  onNext,
  onEditEmailNotification,
  onEditSmsNotification,
  isEmailEditable,
  isSmsEditable,
}) => {
  const ModalContent = () => (
    <>
      <Styled.ModalBodyWrapper>
        <Row>
          <Col md={6}>
            <SubtitlePanel>
              {'1. '}
              <FormattedMessage
                id="Email notification"
                defaultMessage="Email notification"
              />{' '}
              <SubtitleToolTip />
            </SubtitlePanel>
            <Styled.EditPanel>
              <Styled.EditButton outline onClick={onEditEmailNotification}>
                {isEmailEditable ? (
                  <FormattedMessage id="Edit" defaultMessage="Edit" />
                ) : (
                  <FormattedMessage id="Preview" defaultMessage="Preview" />
                )}
              </Styled.EditButton>
            </Styled.EditPanel>
          </Col>
          <Col md={6}>
            <SubtitlePanel>
              {'2. '}
              <FormattedMessage
                id="SMS notification"
                defaultMessage="SMS notification"
              />
            </SubtitlePanel>
            <Styled.EditPanel>
              <Styled.EditButton outline onClick={onEditSmsNotification}>
                {isSmsEditable ? (
                  <FormattedMessage id="Edit" defaultMessage="Edit" />
                ) : (
                  <FormattedMessage id="Preview" defaultMessage="Preview" />
                )}
              </Styled.EditButton>
            </Styled.EditPanel>
          </Col>
        </Row>
      </Styled.ModalBodyWrapper>
      <ModalFooter
        onBack={onBack}
        onNext={onNext}
        isLoading={isLoading}
        nextMessageId="Confirm2"
      />
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      onClose={onClose}
      closeIconEnabled={true}
    >
      <ModalHeader>
        <FormattedMessage
          id="Notification messages"
          defaultMessage="Notification messages"
        />
      </ModalHeader>

      {isLoading ? (
        <Content fluid>
          <PageLoader />
        </Content>
      ) : (
        <ModalContent />
      )}
    </Modal>
  );
};

export default SelectEditTypeModal;
